import React from 'react';

export default function Header({ title, style }) {
  return (
    <div className={'header'} style={style ? style : null}>
      <div className={'title'}>{title}</div>
    </div>
  );
}
